/* unplugin-vue-components disabled */import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/404_images/404.png';
import _imports_1 from '@/assets/404_images/404_cloud.png';
const _withScopeId = n => (_pushScopeId("data-v-58bb9091"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "wscn-http404-container"
};
const _hoisted_2 = {
  class: "wscn-http404"
};
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"pic-404\" data-v-58bb9091><img class=\"pic-404__parent\" src=\"" + _imports_0 + "\" alt=\"404\" data-v-58bb9091><img class=\"pic-404__child left\" src=\"" + _imports_1 + "\" alt=\"404\" data-v-58bb9091><img class=\"pic-404__child mid\" src=\"" + _imports_1 + "\" alt=\"404\" data-v-58bb9091><img class=\"pic-404__child right\" src=\"" + _imports_1 + "\" alt=\"404\" data-v-58bb9091></div>", 1);
const _hoisted_4 = {
  class: "bullshit"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "bullshit__oops"
}, " 404错误! ", -1));
const _hoisted_6 = {
  class: "bullshit__headline"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "bullshit__info"
}, " 对不起，您正在寻找的页面不存在。尝试检查URL的错误，然后按浏览器上的刷新按钮或尝试在我们的应用程序中找到其他内容。 ", -1));
export default {
  __name: '404',
  setup(__props) {
    let message = computed(() => {
      return '找不到网页！';
    });
    return (_ctx, _cache) => {
      const _component_router_link = _resolveComponent("router-link");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, [_hoisted_5, _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(message)), 1), _hoisted_7, _createVNode(_component_router_link, {
        to: "/index",
        class: "bullshit__return-home"
      }, {
        default: _withCtx(() => [_createTextVNode(" 返回首页 ")]),
        _: 1
      })])])]);
    };
  }
};